import { render, staticRenderFns } from "./radio-button-template.vue?vue&type=template&id=49971625&"
import script from "./radio-button-template.vue?vue&type=script&lang=js&"
export * from "./radio-button-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports